import { APP_INITIALIZER } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { registerFontAwesomeIcons } from './font-awesome.icons';

export function fontAwesomeInitializer(library: FaIconLibrary) {
  return () => registerFontAwesomeIcons(library);
}

const provideFontAwesome = [
  {
    provide: APP_INITIALIZER,
    useFactory: fontAwesomeInitializer,
    deps: [FaIconLibrary],
    multi: true,
  },
];
export default provideFontAwesome;
